import React, { Component } from 'react'

import styled from '@emotion/styled'
import StyleVariales from '../styles/styles'

// STYLE ##########################################################

const sv = StyleVariales

const StyledSegment = styled(`div`)`
  transition: left .4s ease;
  // background: ${sv.colors.cta};
  border-top: 2px solid ${sv.colors.cta};
  // border-bottom-color: rgba(0,0,0,0);
  opacity: .75;
  position: absolute;
  left: ${props => props.position}%;
  top: 2px;
  pointer-events: none;
  height: 3px;
  width: ${props => props.size}%;
  // border-radius: 2px;
`

// COMPONENT ##########################################################

class Segment extends Component {

  /// RENDER ###################################################################

  render() {
    return (
      <StyledSegment position={this.props.position} size={this.props.size} />
    )
  }
}

export default Segment
